"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const storm_ui_1 = require("@amzn/storm-ui");
const regionUtils_1 = require("../../../utils/regionUtils");
const TranslationProvider_1 = require("../TranslationProvider/TranslationProvider");
const StyledRadioGroup = (0, styled_components_1.default)(storm_ui_1.RadioGroup) `
  padding: 20px;
  
  
margin-bottom: -4px;
  &&:first-of-type {
    margin-top: -4px;
  }
  
`;
const Container = (0, styled_components_1.default)('div') `
  padding: ${({ theme }) => theme.spacing.small};
  ${({ theme }) => theme.spacing.base};
  padding-block-start: ${({ theme }) => theme.spacing.mini};
  padding-block-end: ${({ theme }) => theme.spacing.small};
`;
const RegionRadioGroup = ({ id, accounts, onChange, selected, }) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    const handleChange = (value, event) => {
        // Get Account from Region
        const selectedAccount = accounts.find((a) => a.regionId === value);
        if (selectedAccount) {
            onChange(selectedAccount, event);
        }
    };
    return ((0, jsx_runtime_1.jsx)(Container, { children: (0, jsx_runtime_1.jsx)(StyledRadioGroup, { id: id, name: "radio-group", selectedValue: selected.regionId, onChange: handleChange, children: accounts.map(({ regionId }) => {
                return ((0, jsx_runtime_1.jsx)(storm_ui_1.RadioButton, { id: `${id}-${regionId}`, label: translate((0, regionUtils_1.getRegionLabel)(regionId)), value: regionId, inline: true, "data-testid": `radio-group-${regionId}` }, `${id}-${regionId}`));
            }) }) }));
};
exports.default = RegionRadioGroup;
//# sourceMappingURL=RegionRadioGroup.js.map